import commonGame from '../commonGame';

export default class PaletteButton extends PIXI.Container{
	constructor() {
		super();
		// Attributes
		this._button = null;
		this._selectionSprite = null;
		this._shineOverlay = null;
		this._type = null;


		// Signals.
		this.signals = {};
		this.signals.onClick = new P3.utils.MiniSignal();
	}

	init() {
		// Button.
		const btnStatesAux = new P3.ButtonStates(
			P3.assets.texture('icon_colour_palette_bg'),
			P3.assets.texture('icon_colour_palette_bg'),
			P3.assets.texture('icon_colour_palette_bg'));
		this._button = new P3.Button(btnStatesAux);
		this._button.anchor = new PIXI.Point(0.5, 0.5);
		this._button.signals.click.add(()=>{
			this.signals.onClick.dispatch();
		}, this);
		this.addChild(this._button);

		// Selection sprite.
		this._selectionSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
		this._selectionSprite.x = -60;
		this._selectionSprite.y = 21;
		this._selectionSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._button._animation.addChild(this._selectionSprite);

		this._shineOverlay = new PIXI.Sprite(P3.assets.texture('btns_colour_overlay'));
		this._shineOverlay.anchor = new PIXI.Point(0.5, 0.5);
		this._shineOverlay.blendMode = PIXI.BLEND_MODES.ADD;
		this._shineOverlay.alpha = 0.4;
		this._selectionSprite.addChild(this._shineOverlay);
	}

	setup(selection, toolType) {
		this._type = toolType;

		this._selectionSprite.tint = 0xffffff;

		switch (this._type) {
			case commonGame.TOOL.BRUSH:
			case commonGame.TOOL.PENCIL:
			case commonGame.TOOL.INK_POT:
			case commonGame.TOOL.SPRAY:
			case commonGame.TOOL.BUCKET: {
				this._shineOverlay.visible = true;

				this._button._currentNormalTexture = P3.assets.texture('icon_colour_palette_bg');
				this._button._currentOverTexture = P3.assets.texture('icon_colour_palette_bg');
				this._button._currentDownTexture = P3.assets.texture('icon_colour_palette_bg');
				this._button._background.texture = this._button._currentNormalTexture;

				if (selection.indexOf('#') === 0) {
					this._selectionSprite.texture = P3.assets.texture('btns_colour_white');
					this._selectionSprite.tint = parseInt('0x' + selection.substring(1));
				}
				else
					this._selectionSprite.texture = P3.assets.texture(commonGame.TEXTURE_BUTTON_BASE_ID + selection.substring(selection.length - 2));

				this._selectionSprite.scale.x = -0.8;
				this._selectionSprite.scale.y = 0.8;

				break;
			}
			case commonGame.TOOL.STAMP: {
				this._shineOverlay.visible = false;

				this._button._currentNormalTexture = P3.assets.texture('icon_stamp_palette_bg');
				this._button._currentOverTexture = P3.assets.texture('icon_stamp_palette_bg');
				this._button._currentDownTexture = P3.assets.texture('icon_stamp_palette_bg');
				this._button._background.texture = this._button._currentNormalTexture;

				this._selectionSprite.texture = P3.assets.texture(selection);
				this._selectionSprite.scale.x = -1;
				this._selectionSprite.scale.y = 0.8;

				break;
			}
		}
	}

	setInteractive(isInteractive){
		this._button.interactive = isInteractive;
		this._button.alpha = isInteractive ? 1 : 0.5;
		this._selectionSprite.alpha = this._button.alpha;
	}

	get type(){
		return this._type;
	}
}